import DictionarySelectFactory from '../../../components/common/containers/DictionarySelectFactory';
import { Instances } from '../../../constants';
import { CountryType, DefaultPropertyType } from '../../../interface';

const valueToOption = (data: Array<CountryType>) =>
	data.map<DefaultPropertyType>(
		(item) => {
			let countryOption:any=[];
		Object.entries(item).map((i:any)=>{
				const [value,label] =i
				countryOption.push({
					label:label as string,
					value,
				})
			})
			return countryOption;
		}
	);

export default DictionarySelectFactory(
	Instances.insightCountries,
	valueToOption
);
